import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { QueryClientProvider } from '@tanstack/react-query';

import { msalInstance } from './lib/msal/msalInstance';
import { queryClient } from './lib/react-query/queryClient';
import { setupAxiosInterceptors } from './lib/axios/setupAxiosInterceptors';
import { UserSessionProvider } from './providers/UserSessionProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { ToastProvider } from './providers/ToastProvider';
import App from './App';

msalInstance.initialize().then(() => {
  setupAxiosInterceptors(msalInstance);
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <UserSessionProvider>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </ThemeProvider>
          </QueryClientProvider>
        </UserSessionProvider>
      </MsalProvider>
    </StrictMode>
  );
});
